import ujs from "@rails/ujs";
if (!window._rails_loaded) {
  ujs.start();
}